import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { xetHocVuApi } from "../../../api/xet-hoc-vu/xetHocVuApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eXetHocVuActionIds, IXetHocVuActionTypes } from "../../action-types/xet-hoc-vu/IXetHocVuActions";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { IProcessXetHocVuRequest } from "../../../model/request/xet-hoc-vu/IProcessXetHocVuRequest";

export function* xetHocVuSaga() : any {
    yield takeLatest(eXetHocVuActionIds.LOAD_BY_DOT_XET_START, loadByDotXetHocVuWoker);
    yield takeLatest(eXetHocVuActionIds.XET_START, xetHocVuWorker);
}

function* loadByDotXetHocVuWoker(action: IXetHocVuActionTypes): any {
        const id_dot_xet = action.payload as number;
        const response: IBaseResponse = yield call(xetHocVuApi.SelectByDotXet, id_dot_xet);
        if (response.is_success) {
            yield put(rootActions.xetHocVu.xetHocVu.LOAD_BY_DOT_XET_SUCCESS(toLowerCaseDeep(response.data)));
        } else {
            yield put(rootActions.xetHocVu.xetHocVu.LOAD_BY_DOT_XET_ERROR(response.message ?? "Không thể tải dữ liệu"));
        }
}

function* xetHocVuWorker(action: IXetHocVuActionTypes): any {
    const request = action.payload as IProcessXetHocVuRequest;
    const response: IBaseResponse = yield call(xetHocVuApi.XetHocVu, request);
    if (response.is_success) {
        yield put(rootActions.xetHocVu.xetHocVu.XET_SUCCESS(response.message ?? "Xét học vụ thành công"));
    } else {
        yield put(rootActions.xetHocVu.xetHocVu.XET_ERROR(response.message ?? "Không thể thực hiện xét học vụ"));
    }
}